
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CancelButton from "../buttons/CancelButton.vue";
import DangerButton from "../buttons/DangerButton.vue";
import EditFrame from "../EditFrame.vue";

@Component({
  components: {
    EditFrame,
    CancelButton,
    DangerButton,
  },
})
export default class NumberOfSpaces extends Vue {
  @Prop()
  capacity!: number;

  @Prop({
    default: false,
  })
  hideControls!: boolean;
  @Prop({ default: false }) editMode!: boolean;
  editedCapacity = 0;

  mounted(): void {
    this.importData();
    console.log("capacity", this.capacity);
  }

  @Watch("capacity")
  onCapacityChanged(): void {
    this.importData();
  }

  importData(): void {
    this.editedCapacity = this.capacity;
  }

  onInput(): void {
    this.$emit("input", this.editedCapacity);
  }
}
